module.exports = __webpack_public_path__ + "img/TianSheng.4c92cb63.png";